export default {"src":"/_next/static/media/inupt.7f94fc5a.svg","height":66,"width":1776,"blurWidth":0,"blurHeight":0};